<template>
    <div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title has-text-white">Are you sure you want to cancel?</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('close')"/>
            </header>
            <section class="modal-card-body has-background-dvodark">
                <div class="buttons is-centered">
                <button class="button is-primary is-large" @click="cancelWarranty(); $emit('close');">YES</button>
                <button class="button is-link is-large" @click="$emit('close')">NO</button>
                </div>
            </section>
            <footer class="modal-card-foot">
            </footer>
        </div>
    </div>
</template>

<script>
import { warrantyHandler, cancellationSes } from '../graphql/mutations'
import { API } from 'aws-amplify';
export default {
    data(){
    return{
        id: this.initId,
        companyId: this.initCompany
    }
    },
    props: ['initId', 'initCompany'],
    methods:{
    async cancelWarranty() {
      await API.graphql({
        query: warrantyHandler,
        variables: {
          input: {
            request_type: 'cancel',
            id: this.id
          }
        }
      });

      await API.graphql({
        query: cancellationSes,
        variables:{
          input:{
            warranty_id: this.$route.params.id,
            status: 'CANCELLED',
            id: this.companyId
          }
        }
      })
      this.$router.push({
        name: 'WarrantyCreditRequest'
      })
    },
}
}
</script>